module.exports = new __parcel__URL__("Employee Handbook Hover.40d99a75.svg").toString();